import { Injectable, OnInit} from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class Constants implements OnInit
{
    public static get API_BASE(): string { return environment.apiUrl; };
    public static get API_STITCH_BASE(): string { return environment.stitchApiUrl; };

    constructor(){}
    ngOnInit(){}

}



// WEBPACK FOOTER //
// ./src/app/services/constants/constants.service.ts